import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function InventoryAdjustment() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [items, setItems] = useState([]);
    const [editId, setEditId] = useState(null);
    const [formData, setFormData] = useState({
        item: "", previous_stock: "", new_stock: "", reason: ""
    });
    useEffect(() => {
        getAdjustments();
        getItems();
    }, []);
    const getAdjustments = () => {
        setLoading(true);
        axios
            .get(baseUrl + "inventory-adjustment/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getItems = () => {
        axios
            .get(baseUrl + "inventory-item/")
            .then((res) => {
                setItems(res.data);
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        if (name === "item") {
            const selectedItem = items.find((x) => x.id === parseInt(value));
            setFormData({
                ...formData, item: value, previous_stock: selectedItem ? selectedItem.current_stock : ""
            });
        } else {
            setFormData({
                ...formData, [name]: value
            });
        }
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            item: "", previous_stock: "", new_stock: "", reason: ""
        });
    };
    const editData = (row) => {
        setEditId(row.id);
        setFormData({
            item: row.item?.id, previous_stock: row.previous_stock, new_stock: row.new_stock, reason: row.reason
        });
    };
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Inventory Adjustment?", icon: "warning", showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .delete(`delete-inventory-adjustment/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted", "", "success");
                        getAdjustments();
                    });
            }
        });
    };
    const saveData = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = new FormData();
            data.append("item", formData.item);
            data.append("previous_stock", formData.previous_stock);
            data.append("new_stock", formData.new_stock);
            data.append("reason", formData.reason);
            data.append("addedby", userName);
            data.append("ip_add", ipAddress);
            if (editId === null) {
                await axios.post(baseUrl + "inventory-adjustment/", data);
            } else {
                await axios.put(baseUrl + `update-inventory-adjustment/${editId}/`, data);
            }
            Swal.fire("Success", editId === null ? "Inventory Adjustment Saved" : "Inventory Adjustment Updated", "success");
            clearForm();
            getAdjustments();
        } catch (error) {
            Swal.fire("Error", "Unable to Save Inventory Adjustment", "error");
        }
        setLoading(false);
    };
    const columns = [{
        field: "item", headerName: "Item", width: 220, renderCell: (params) => (<span>
            {params.row.item?.item_name}
        </span>)
    }, {
        field: "previous_stock", headerName: "Previous Stock", width: 150
    }, {
        field: "new_stock", headerName: "New Stock", width: 150
    }, {
        field: "reason", headerName: "Reason", width: 350
    }, {
        field: "action", headerName: "Action", width: 180, renderCell: (params) => (<>

                <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => editData(params.row)}
                >
                    Edit
                </button>

                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteData(params.row.id)}
                >
                    Delete
                </button>

            </>)
    }];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">
                        Inventory Adjustment
                    </h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">

                            <div className="col-md-4 mb-3">

                                <label>
                                    Inventory Item
                                </label>

                                <select
                                    className="form-control"
                                    name="item"
                                    value={formData.item}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Item
                                    </option>

                                    {items.map((item) => (<option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.item_name} - {item.owner.name}
                                        </option>))}

                                </select>

                            </div>


                            <div className="col-md-4 mb-3">

                                <label>
                                    Previous Stock
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control"
                                    name="previous_stock"
                                    value={formData.previous_stock}
                                    readOnly
                                />
                            </div>


                            <div className="col-md-4 mb-3">

                                <label>
                                    New Stock
                                </label>

                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control"
                                    name="new_stock"
                                    value={formData.new_stock}
                                    onChange={handleChange}
                                    required
                                />

                            </div>


                            <div className="col-md-12 mb-3">

                                <label>
                                    Reason
                                </label>

                                <textarea
                                    className="form-control"
                                    rows="3"
                                    name="reason"
                                    value={formData.reason}
                                    onChange={handleChange}
                                    required
                                />

                            </div>

                            <div className="col-md-12 mt-3">


                                <button

                                    type="submit"

                                    className="btn btn-success me-2"

                                    disabled={loading}

                                >

                                    {editId === null ? "Save Adjustment" : "Update Adjustment"}

                                </button>


                                <button

                                    type="button"

                                    className="btn btn-secondary"

                                    onClick={clearForm}

                                >

                                    Clear

                                </button>

                            </div>


                        </div>

                    </form>

                </div>

            </div>
            <div className="card shadow mt-3">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Inventory Adjustment List
                    </h5>

                </div>

                <div className="card-body">

                    <div
                        style={{
                            height: 600, width: "100%",
                        }}
                    >

                        <ERPDataGrid
                            rows={rows}
                            columns={columns}
                            loading={loading}
                            getRowId={(row) => row.id}
                            pageSizeOptions={[10, 25, 50, 100,]}
                            disableRowSelectionOnClick
                        />

                    </div>

                </div>

            </div>

        </div>);
}
export default InventoryAdjustment;